export type Locale = 'es' | 'en';

export const messages: Record<Locale, Record<string, string>> = {
  es: {
    'app.loading': 'Cargando…',
    'app.search.placeholder': 'Buscar en MyPetLive',
    'app.notifications': 'Notificaciones',
    'app.help': 'Ayuda',
    'app.profile': 'Perfil',
    'app.language': 'Idioma',
    'role.tenant': 'Inquilino',
    'role.landlord': 'Propietario',
    'role.professional': 'Profesional',
    'role.agency': 'Inmobiliaria',
    'role.admin': 'Administrador',
    'nav.tenant.home': 'Inicio',
    'nav.tenant.search': 'Buscar vivienda',
    'nav.tenant.applications': 'Solicitudes',
    'nav.tenant.contracts': 'Contratos',
    'nav.tenant.payments': 'Pagos',
    'nav.tenant.incidents': 'Incidencias',
    'nav.tenant.profile': 'Mi perfil',
    'nav.tenant.kyc': 'Verificación KYC',
    'nav.tenant.pro': 'Solvencia PRO',
    'nav.tenant.services': 'Servicios post-firma',
    'nav.landlord.home': 'Inicio',
    'nav.landlord.properties': 'Mis inmuebles',
    'nav.landlord.requests': 'Solicitudes y visitas',
    'nav.landlord.candidates': 'Candidatos',
    'nav.landlord.contracts': 'Contratos',
    'nav.landlord.deposits': 'Fianzas',
    'nav.landlord.payments': 'Pagos',
    'nav.landlord.incidents': 'Incidencias',
    'nav.landlord.professionals': 'Profesionales',
    'nav.landlord.tax': 'Fiscalidad',
    'nav.professional.home': 'Inicio',
    'nav.professional.offers': 'Ofertas',
    'nav.professional.jobs': 'Trabajos',
    'nav.professional.billing': 'Facturación',
    'nav.professional.reputation': 'Reputación',
    'nav.agency.home': 'Inicio',
    'nav.agency.visits': 'Visitas',
    'nav.agency.captacion': 'Captación',
    'nav.agency.contracts': 'Contratos asistidos',
    'nav.agency.commissions': 'Comisiones',
    'nav.admin.dashboard': 'Panel',
    'nav.admin.users': 'Usuarios',
    'nav.admin.payments': 'Pagos/Escrow',
    'nav.admin.deposits': 'Depósitos',
    'nav.admin.catalog': 'Catálogo servicios',
    'nav.admin.legal': 'Textos legales',
    'layout.no-access.title': 'No tienes acceso',
    'layout.no-access.description': 'Tu rol activo no puede acceder a esta sección.',
    'layout.no-access.cta': 'Cambiar de rol',
    'demo.toggle.title': 'Modo demo',
    'demo.toggle.description': 'Activa o desactiva módulos mock para pruebas.',
    'demo.toggle.utilities': 'Utilities',
    'demo.toggle.insurance': 'Seguros',
    'demo.toggle.close': 'Cerrar',
  },
  en: {
    'app.loading': 'Loading…',
    'app.search.placeholder': 'Search MyPetLive',
    'app.notifications': 'Notifications',
    'app.help': 'Help',
    'app.profile': 'Profile',
    'app.language': 'Language',
    'role.tenant': 'Tenant',
    'role.landlord': 'Landlord',
    'role.professional': 'Professional',
    'role.agency': 'Agency',
    'role.admin': 'Admin',
    'nav.tenant.home': 'Home',
    'nav.tenant.search': 'Search homes',
    'nav.tenant.applications': 'Applications',
    'nav.tenant.contracts': 'Contracts',
    'nav.tenant.payments': 'Payments',
    'nav.tenant.incidents': 'Incidents',
    'nav.tenant.profile': 'Profile',
    'nav.tenant.kyc': 'KYC',
    'nav.tenant.pro': 'PRO badge',
    'nav.tenant.services': 'After signing',
    'nav.landlord.home': 'Home',
    'nav.landlord.properties': 'Properties',
    'nav.landlord.requests': 'Requests & visits',
    'nav.landlord.candidates': 'Candidates',
    'nav.landlord.contracts': 'Contracts',
    'nav.landlord.deposits': 'Deposits',
    'nav.landlord.payments': 'Payments',
    'nav.landlord.incidents': 'Incidents',
    'nav.landlord.professionals': 'Professionals',
    'nav.landlord.tax': 'Taxes',
    'nav.professional.home': 'Home',
    'nav.professional.offers': 'Offers',
    'nav.professional.jobs': 'Jobs',
    'nav.professional.billing': 'Billing',
    'nav.professional.reputation': 'Reputation',
    'nav.agency.home': 'Home',
    'nav.agency.visits': 'Visits',
    'nav.agency.captacion': 'Capture',
    'nav.agency.contracts': 'Assisted contracts',
    'nav.agency.commissions': 'Commissions',
    'nav.admin.dashboard': 'Dashboard',
    'nav.admin.users': 'Users',
    'nav.admin.payments': 'Payments/Escrow',
    'nav.admin.deposits': 'Deposits',
    'nav.admin.catalog': 'Catalog',
    'nav.admin.legal': 'Legal texts',
    'layout.no-access.title': 'Access denied',
    'layout.no-access.description': 'Your active role cannot access this section.',
    'layout.no-access.cta': 'Switch role',
    'demo.toggle.title': 'Demo mode',
    'demo.toggle.description': 'Toggle mock modules for demos.',
    'demo.toggle.utilities': 'Utilities',
    'demo.toggle.insurance': 'Insurance',
    'demo.toggle.close': 'Close',
  },
};
